import moment from "moment";

/**
 * Map Activity Report activity_type strings to Past Activities–style
 * card colors, icons, and client-side filter buckets.
 */

export const ACTIVITY_FEED_FILTER_ALL = "All";

/** Default feed window: last 7 calendar days (inclusive), local start/end of day. */
export const getDefaultActivityFeedDateRange = () => ({
  startDate: moment().subtract(6, "days").startOf("day").toISOString(),
  endDate: moment().endOf("day").toISOString(),
});

export const ACTIVITY_FEED_TYPE_STYLES = {
  Phone: {
    borderLeft: "3px solid #50E3C2",
    backgroundColor: "rgba(80, 227, 197, 0.3)",
    color: "white",
  },
  Text: {
    borderLeft: "3px solid #C48E48",
    backgroundColor: "rgb(87, 71, 49,0.3)",
    color: "white",
  },
  Email: {
    borderLeft: "3px solid #FF7A00",
    backgroundColor: "rgba(255, 122, 0, 0.3)",
    color: "white",
  },
  Appointment: {
    borderLeft: "3px solid #92af00",
    backgroundColor: "rgba(183, 214, 135, 0.3)",
    color: "white",
  },
  "Web Form": {
    borderLeft: "3px solid #5C6BC0",
    backgroundColor: "rgba(92, 107, 192, 0.3)",
    color: "white",
  },
  Traffic: {
    borderLeft: "3px solid #00ff40",
    backgroundColor: "rgba(3, 255, 66, 0.3)",
    color: "white",
  },
  "Saved Floor Plan": {
    borderLeft: "3px solid #1B5E20",
    backgroundColor: "rgba(27, 94, 32, 0.3)",
    color: "white",
  },
  "Favorite Floor Plan": {
    borderLeft: "3px solid #880E4F",
    backgroundColor: "rgba(136, 14, 79, 0.3)",
    color: "white",
  },
  Default: {
    borderLeft: "3px solid #888",
    backgroundColor: "rgba(136, 136, 136, 0.25)",
    color: "white",
  },
};

export const ACTIVITY_FEED_FILTER_OPTIONS = {
  All: "All",
  Appointment: "Appointments",
  "Web Form": "Web Form",
  Traffic: "Traffic",
  Email: "Email In",
  Phone: "Phone In",
  Text: "Text In",
  "Saved Floor Plan": "Saved Floor Plan",
  "Favorite Floor Plan": "Favorite Floor Plan",
};

/** Map UI type filter category -> activity_type values for server filtering. */
export const ACTIVITY_FEED_TYPES_BY_CATEGORY = {
  Appointment: [
    "Appointment Held",
    "Appointment Set",
    "Appointment Canceled",
  ],
  "Web Form": ["Web Form"],
  Traffic: ["Traffic"],
  Email: ["Email In"],
  Phone: ["Phone Call In"],
  Text: ["Text In"],
  "Saved Floor Plan": ["Saved Floor Plan"],
  "Favorite Floor Plan": ["Favorite Floor Plan"],
};

export const getActivityFeedTypesForCategory = (category) => {
  if (!category || category === ACTIVITY_FEED_FILTER_ALL) return undefined;
  return ACTIVITY_FEED_TYPES_BY_CATEGORY[category];
};

/**
 * Bucket an Activity_Report.activity_type into a feed filter category.
 */
export const getActivityFeedCategory = (activityType = "") => {
  const type = activityType || "";
  if (type === "Text In") return "Text";
  if (type === "Phone Call In") return "Phone";
  if (type === "Email In") return "Email";
  if (type.includes("Appointment")) return "Appointment";
  if (type.includes("Web Form") || type === "Web_Form") return "Web Form";
  if (type.includes("Traffic")) return "Traffic";
  if (type === "Favorite Floor Plan") return "Favorite Floor Plan";
  if (type === "Saved Floor Plan") return "Saved Floor Plan";
  return "Default";
};

/**
 * Map report activity_type to getIconByEvent titles where possible.
 */
export const getActivityFeedIconTitle = (activityType = "") => {
  const type = activityType || "";
  if (type === "Text In") return "Text In";
  if (type === "Phone Call In") return "Call In";
  if (type === "Email In") return "Email In";
  if (type.includes("Appointment")) return "Appointment";
  if (type.includes("Web Form") || type === "Web_Form") return "Web Form";
  if (type.includes("Traffic")) return "Traffic";
  if (type === "Favorite Floor Plan") return "Favorite Floor Plan";
  if (type === "Saved Floor Plan") return "Saved Floor Plan";
  return null;
};

export const getActivityFeedCardStyle = (activityType) => {
  const category = getActivityFeedCategory(activityType);
  return (
    ACTIVITY_FEED_TYPE_STYLES[category] || ACTIVITY_FEED_TYPE_STYLES.Default
  );
};

export const formatActivityFeedCustomerTypes = (types = []) => {
  if (!types?.length) return "———";
  return types.map((t) => t.name || t).join(", ");
};

export const formatActivityFeedCommunities = (communities = []) => {
  if (!communities?.length) return "———";
  return communities.map((c) => c.name).filter(Boolean).join(", ");
};

export const formatActivityFeedUserName = (csm) => {
  if (!csm) return "———";
  return [csm.first_name, csm.last_name].filter(Boolean).join(" ") || "———";
};
